module.exports = __webpack_public_path__ + "img/vipEquityF.678dae4c.png";